<style lang="less" scoped>
  .category-content {
    padding: 0 10px;
  }
</style>
<template>
  <div>
    <v-row>
      <VRippleCol md="6">
        名称：
        {{ info.remark }}
      </VRippleCol>
      <VRippleCol md="6">
        申请人：
        {{ (info.customer&&info.customer.account) || '-' }}
      </VRippleCol>
      <VRippleCol md="6">
        公司主体：
        <CompanyName 
          :id="info.company_id"
          :short="true"
        />
      </VRippleCol>
      <VRippleCol md="6">
        团队主体：
        <TeamName 
          :id="info.team_id"
          :short="true"
        />
      </VRippleCol>
    </v-row>
    <v-row>
      <VRippleCol md="12">
        关联单据：
        <span>
          {{ info.contract_id?info.contract.name:'无' }}
        </span>
      </VRippleCol>
    </v-row>
    <v-row>
      <VRippleCol md="12">
        发票提交方式：
        <span v-if="info.invoices&&info.invoices.length">
          自主提交发票
        </span>
        <span v-else>
          财务代收发票
        </span>
      </VRippleCol>
    </v-row>
    <v-row
      v-if="info.invoices&&info.invoices.length"
    >
      <VRippleCol
        v-for="(invoice,index) in info.invoices"
        :key="index"
        md="12"
      >
        <div>
          <p style="margin:0">
            发票{{ index+1 }}
          </p>
          <p style="margin:0">
            发票编号：{{ invoice.uid }}
          </p>
          <p style="margin:0">
            金额：{{ $util.formatPrice(invoice.price) }}
          </p>
        </div>
      </VRippleCol>
      <!-- express_code -->
    </v-row>
    <v-row
      v-if="info.express_code"
    >
      <VRippleCol
      
        md="12"
      >
        快递单号：{{ info.express_code }}
      </VRippleCol>
      <!-- express_code -->
    </v-row>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import CompanyName from '@/views/components/company/name'
  import TeamName from '@/views/components/team/name'
  // team
  import {BX_CATEGORY_HASH} from "../fields";
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import RoughInvoice from './rough_invoice';
  export default {
    components: { RoughInvoice, VRippleCol, CompanyName, TeamName},
    props: {
      info: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        download_loading: false,
        category_detail_list: []
      }
    },
    computed: {
      ...mapGetters({
        offices_hash: 'async/offices_hash',
      }),
      office_name() {
        if (this.info) {
          const office = this.offices_hash[this.info.office_id];
          return office ? office.name : '-';
        }
        return '-';
      },
      checked_rough_invoices() {
        const arr = [];
        this.category_detail_list.forEach(detail => {
          detail.rough_invoices.forEach(rough_invoice => {
            if (rough_invoice._checkout) {
              arr.push(rough_invoice);
            }
          })
        })
        return arr;
      }
    },
    watch: {
      info: {
        handler() {
          this.genList();
        },
        deep: true
      },
    },
    created() {
      this.genList();
    },
    mounted() {
      //
    },
    methods: {
      genList() {
        const list = [];
        if (this.info) {
          const { category_detail_list = [] } = this.info;
          category_detail_list.forEach((detail) => {
            const item = this.$util.clone(detail);
            item.rough_invoices.forEach((rough_invoice) => {
              rough_invoice._checkout = false;
              if (rough_invoice.ocr_status === 'success') {
                const ocr_res = JSON.parse(rough_invoice.ocr_result);
                rough_invoice.ocr_invoice_list = ocr_res['response']['data']['identify_results'].map(_ => _.details);
              }
            });
            list.push(item);
          });
        }
        this.category_detail_list = list;
      },
      categoryName(category_id) {
        return BX_CATEGORY_HASH[category_id];
      },
      preview(invoice = {}) {
        const filepath = invoice.oss_img_path ? invoice.oss_img_path : invoice.oss_pdf_path;
        if (!filepath) {
          this.$Message.error('未找到文件路径，无法预览');
          return;
        }
        const oss_url = this.$util.publicOSSUrl(filepath);
        window.open(oss_url);
      },
      // 筛选出批量下载的发票
      async batchDownload() {
        this.download_loading = true;
        const { zipfile } = await this.$http.post('expense_group/zip_rough_invoices', {
          reimbursement_id: this.info.id,
          rough_invoice_ids: this.checked_rough_invoices.map(ri => ri.id)
        }).finally(() => { this.download_loading = false })
        const download_url = this.$util.staticFile(zipfile);
        window.open(download_url);

        // 前端下载
        // this.checked_rough_invoices.forEach(invoice => {
        //   this.preview(invoice)
        // })
      },
      selectedAll(type) {
        this.category_detail_list.forEach(detail => {
          detail.rough_invoices.forEach(rough_invoice => {
            rough_invoice._checkout = type;
          });
        });
      },
    }
  }
</script>
